import React, { useState, useEffect } from "react";
import { getFavorites, removeFavorite } from "../services/product";
import { useNavigate } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import ProductCard from "../components/Common/ProductCard";
import WalmartProductCard from "../components/Common/WalmartProductCard";

function Favorites() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        setLoading(true);
        const response = await getFavorites();
        console.log(response);
        setFavorites(response || []);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFavorites();
  }, []);

  const getProductKey = (data) =>
    data?.platform === "walmart" || data?.product_id
      ? data.product_id
      : data.asin;

  const handleCardClick = (asin) => {
    navigate(`/product?asin=${asin}`);
  };

  const handleWalmartClick = (productId) => {
    if (!productId) return;
    navigate(`/walmart-product?product_id=${productId}`);
  };

  const handleRemoveFavorite = async (id) => {
    try {
      await removeFavorite(id);
      setFavorites((prev) =>
        prev.filter((fav) => getProductKey(fav.data) !== id)
      );
    } catch (error) {
      console.error("Error removing favorite:", error);
    }
  };

  return (
    <div className="bg-primary-bg min-h-screen">
      <div className="title border-b-2 border-b-border w-full md:p-[21.5px] p-3 text-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FaHeart className="text-primary text-2xl" />
          <p className="text-white font-bold text-xl">Favorite Products</p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center min-h-[80vh]">
          <div className="text-center text-primary mt-6">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      ) : (
        <div className="p-4 md:p-6">
          {favorites.length === 0 ? (
            <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
              <FaHeart className="text-gray-600 text-6xl mb-4" />
              <h3 className="text-gray-400 text-xl font-semibold mb-2">
                No Favorites Yet
              </h3>
              <p className="text-gray-500 text-sm">
                Start adding products to your favorites to see them here
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
              {favorites.map((favorite) => {
                const data = favorite.data || {};
                const isWalmart =
                  data.platform === "walmart" || (!!data.product_id && !data.asin);
                const key = getProductKey(data) || favorite.id;

                if (isWalmart) {
                  return (
                    <WalmartProductCard
                      key={key}
                      product={data}
                      createdAt={favorite.createdAt}
                      onRemove={() => handleRemoveFavorite(key)}
                      onClick={() => handleWalmartClick(data.product_id)}
                    />
                  );
                }

                return (
                  <ProductCard
                    key={key}
                    product={data}
                    onClick={() => handleCardClick(data.asin)}
                    onRemove={handleRemoveFavorite}
                    showActions={true}
                    createdAt={favorite.createdAt}
                  />
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Favorites;
